import { useTranslation } from '@klv/hooks/useTranslation';
import { generateClassName } from '@klv/shared/utils/functions';
import { Wrapper } from '@klv/utils/wrapper';
import Icon from '@klv/atoms/icon';
import type { IBlogLogoTagline } from './types';
import * as styles from './styles/bloglogotagline.module.scss';


const BlogLogoTagline = ({
  tagline = 'Your owned marketing resource',
  customPadding = { customPaddingBottom: 'default', customPaddingTop: 'default' },
  backgroundColor = 'charcoal',
}: IBlogLogoTagline) => {
  const { t } = useTranslation();
  let formattedTagline = tagline;
  if (tagline === '') {
    formattedTagline = '';
  } else if (t('organisms_blogLogoTag_tagline') ) {
    formattedTagline = t('organisms_blogLogoTag_tagline');
  } 
  
  return (
    <Wrapper customPadding={customPadding} backgroundColor={backgroundColor}>
      <div className={`${styles.blogLogoTagline} ${backgroundColor === 'charcoal' ? styles.dark : styles.light}`}>
        <div className={generateClassName(['grid', styles.styledGrid])}>
          <h1 className={styles.title}>{t('organisms_blogLogoTag_title')}</h1>
          <Icon className={styles.logo}iconName="TheKlaviyoApproachDesktopLogo" />
          {formattedTagline && (<div aria-label={t('organisms_blogLogoTag_tagline')} className={styles.formattedTagline}>{formattedTagline}</div>)}
        </div>
      </div>
    </Wrapper>
  );
};

export default BlogLogoTagline;
